<div class="popular pt-3 pb-5">
    <div class="container-fluid">

        <div class="row text-center m-5">
            <div class="col-md-12">
                <h3>Popular destinations</h3>
                <p>Explore</p>
            </div>
        </div>

      <div class="row">
        <ng-container *ngFor="let item of galleryItems; let i = index">
          <ng-container *ngIf="i === 0">
            <!-- Wide card (col-md-8) -->
            <div class="col-md-8 mb-4">
              <div class="card h-100">
                <div class="card-image-container" [ngStyle]="{'background-image': 'url(assets/img/popular/' + item.gambar + ')'}">
                  <img src="assets/img/logo.png" alt="Logo" class="logo-top-left">
                  <div class="ket">
                    <h3 class="card-title">{{ item.nama_tempat }}</h3>
                    <p class="card-text">{{ item.keterangan }}</p>        
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="i === 1">
            <!-- Wide card (col-md-8) -->
            <div class="col-md-4 mb-4">
              <div class="card h-100">
                <div class="card-image-container" [ngStyle]="{'background-image': 'url(assets/img/popular/' + item.gambar + ')'}">
                  <img src="assets/img/logo.png" alt="Logo" class="logo-top-left">
                  <div class="ket">
                    <h3 class="card-title">{{ item.nama_tempat }}</h3>
                    <p class="card-text">{{ item.keterangan }}</p>        
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          
          <ng-container *ngIf="i === 2">
            <!-- Wide card (col-md-8) -->
            <div class="col-md-4 mb-4">
              <div class="card h-100">
                <div class="card-image-container" [ngStyle]="{'background-image': 'url(assets/img/popular/' + item.gambar + ')'}">
                  <img src="assets/img/logo.png" alt="Logo" class="logo-top-left">
                  <div class="ket">
                    <h3 class="card-title">{{ item.nama_tempat }}</h3>
                    <p class="card-text">{{ item.keterangan }}</p>        
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

            
          <ng-container *ngIf="i === 3">
            <!-- Wide card (col-md-8) -->
            <div class="col-md-8 mb-4">
              <div class="card h-100">
                <div class="card-image-container" [ngStyle]="{'background-image': 'url(assets/img/popular/' + item.gambar + ')'}">
                  <img src="assets/img/logo.png" alt="Logo" class="logo-top-left">
                  <div class="ket">
                    <h3 class="card-title">{{ item.nama_tempat }}</h3>
                    <p class="card-text">{{ item.keterangan }}</p>        
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
  
  
        </ng-container>
      </div>


      <div class="row text-center pb-2">
        <div class="col-md-12">
          
        </div>
     
      </div>
  </div>
</div>
  